import { logger } from '../logger.js';

const isPermutiveSettingsSet = () => window.permutive;

const isGptPermutiveTargetingSet = () => googletag.pubads().getTargeting('permutive').length;

/**
 * Get the permutive segments
 */
const getPermutiveSegments = () => {
  try {
    return window.localStorage._psegs ? JSON.parse(window.localStorage._psegs) : [];
  } catch (error) {
    logger.warn('Prebid: Error processing permutive segments', error.message);
    return [];
  }
};

/**
 * Process data from Permutive segments
 */
const processPermutiveSegments = (segments) => {
  if (segments.length === 0) {
    return [];
  }

  try {
    const psegs = segments
      .map(Number)
      .filter((seg) => seg >= 1000000).map(String);

    const ppam = JSON.parse(window.localStorage._ppam || '[]');
    const pcrprs = JSON.parse(window.localStorage._pcrprs || '[]');

    return psegs.concat(ppam).concat(pcrprs);
  } catch (error) {
    logger.warn('Prebid: Error processing permutive segments _ppam/_pcrprs', error.message);

    return [];
  }
};

/**
 * Get permutive targeting info from local storage and push to gpt.
 */
export const setupPermutiveTargeting = () => {
  if (isPermutiveSettingsSet() && !isGptPermutiveTargetingSet()) {
    const kvs = localStorage.getItem('_pdfps') || '';
    googletag.pubads().setTargeting('permutive', kvs ? JSON.parse(kvs) : []);
  }
};

/**
 * Add the number of permutive segments.
 */
export const addPermutiveSegmentsToLux = () => {
  const psegs = getPermutiveSegments();

  window.LUX.addData('permutive-segments', psegs.length);
};

/**
 * Transform data from permutive.
 */
export const transformPermutiveData = () => {
  const permutive = getPermutiveSegments();

  return {
    permutive,
    page: JSON.stringify(window.IM?.PermutiveModel || {}),
    p_standard: processPermutiveSegments(permutive),
  };
};
